export default __webpack_public_path__ + "static/media/share.5c3e05ce.png";